import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {Injectable, isDevMode} from '@angular/core';

@Injectable()
export class LogInterceptor implements HttpInterceptor {

  constructor() { }

  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (isDevMode()) {
      const started = Date.now();

      return next.handle(req).pipe(tap(event => {
        if (event.type === HttpEventType.Response) {
          const elapsed = Date.now() - started;
        }
      }));
    }

    return next.handle(req);
  }
}
